<template>
  <div :class="`row ${mobile_view ? 'pt-1 pb-2' : 'pt-10 pb-10'}`">
    <div class="col-lg-9 col-md-8 col-sm-9 col-8">
      <input
        v-model="discount_code"
        placeholder="CÓDIGO DE DESCUENTO"
        :class="`input-nv-discount ${input_type} mb-2 mr-2`"
        id="discount"
      >
    </div>
    <div class="col-lg-3 col-md-4 col-sm-3 col-4 d-flex justify-content-end">
      <v-btn
        color="primary"
        class="nv-btn nv-btn-small nv-btn-hover mt-2"
        elevation="0"
        @click="usedDiscountCode()"
        :loading="loading_btn_discount"
        :disabled="disabled_btn || disabledBtnDiscount"
      >
        USAR
      </v-btn>
    </div>
  </div>
</template>

<script>
import PaymentService from '@/services/payment.service'
import { mapState, mapGetters } from 'vuex'

export default {
  props: {
    input_type: {
      default: 'input-nv-discount-color-light',
      type: String
    },
    mobile_view: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      discount_code: '',
      data_discount: null,
      loading_btn_discount: false,
      disabled_btn: false
    }
  },
  computed: {
    ...mapState(['cart', 'is_auth', 'cart_total', 'disabledBtnDiscount']),
    ...mapGetters(['total_cart', 'quantity_items_cart'])
  },
  methods: {
    async usedDiscountCode() {
      try {
        let code = this.discount_code.trim()
        if (code != '') {
          this.loading_btn_discount = true
          let url = 'used-discount-code'
          if (this.is_auth) {
            url = 'client-used-discount-code'
          }
          const { data:res } = await PaymentService.usedDiscountCode(url, {
            code: code
          })
          if (res.success) {
            this.data_discount = res.data
            this.appliedDiscount(this.data_discount.type)
          } else {
            this.$swal(res.error, '', 'warning')
          }
          this.loading_btn_discount = false
        }
      } catch (error) {
        this.loading_btn_discount = false
      }
    },
    calculateDiscount(type, value_discount) {
      if (type == 'percent') {
        value_discount = value_discount / 100
        return this.total_cart * value_discount
      }
      if (type == 'amount_fixed') {
        return parseFloat(value_discount)
      }
    },
    appliedDiscountPercentOrFixedAmount() {
      let d = this.data_discount
      let option_products = d.opt_applied_product
      let opt_min = d.opt_require_min
      let value_discount = d.value_discount
      let total_cart = this.cart_total
      let total_discount = 0

      let cart_products = this.cart.cart_products
      let products_discount = d.products

      let applied = true

      if (option_products != 'all') {
        let products_discount_ids = products_discount.map(i => i.producteable_id).filter(i => !!i)

        //eliminar duplicados
        products_discount_ids = new Set(products_discount_ids)
        products_discount_ids = [...products_discount_ids]

        var products_exists = cart_products.filter(i => products_discount_ids.includes(i.variant_id))
          .map(i => i.variant_id)
        if (!products_exists.length) {
          return this.$swal('No cumples las condiciones para aplicar este descuento', '', 'warning')
        }
      }

      if (opt_min != 'no') {
        //cantidad minima
        if (opt_min == 'qty_min') {
          let products_quantity
          if (option_products != 'all') {
            products_quantity = cart_products.filter(i => products_exists.includes(i.variant_id))
              .map(i => i.quantity)
              .reduce((a, b) => a + b)
          } else {
            products_quantity = this.quantity_items_cart
          }

          //si la cantidad minima requerida es igual a lo que tiene en el carrito
          if (products_quantity >= parseInt(d.val_require_min)) {
            const numberDiscountAmount = parseInt(products_quantity) / parseInt(d.val_require_min)
            const amountForApply = value_discount * parseInt(numberDiscountAmount)
            total_discount = this.calculateDiscount(d.type, amountForApply)
          } else {
            applied = false
          }
        }

        //si el monto del carrito es mayor o igual al minimo para aplicar el descuento
        if (opt_min == 'amount_min') {
          if (total_cart >= d.val_require_min) {
            total_discount = this.calculateDiscount(d.type, value_discount)
          } else {
            applied = false
          }
        }

      } else {
        total_discount = this.calculateDiscount(d.type, value_discount)
      }

      total_cart = (total_cart - total_discount).toFixed(2)
      this.$emit(
        'appliedDiscount',
        {
          applied: applied,
          discount: d,
          total: parseFloat(total_cart),
          total_discount: total_discount
        }
      )
      if (applied) {
        this.$store.dispatch('selectDiscount', {
          discount: d,
          amount_discount: total_discount
        })
      }
    },
    appliedDiscountShippingFree() {
      let d = this.data_discount
      let opt_min = d.opt_require_min
      let total_cart = this.total_cart
      let applied = true

      if (opt_min != 'no') {
        //cantidad minima
        if (opt_min == 'qty_min') {
          //si la cantidad minima requerida es igual a lo que tiene en el carrito
          if (this.quantity_items_cart >= parseInt(d.val_require_min)) {
            this.$emit('appliedDiscount', { discount: d})
          } else {
            applied = false
          }
        }

        //si el monto del carrito es mayor o igual al minimo para aplicar el descuento
        if (opt_min == 'amount_min') {
          if (total_cart >= d.val_require_min) {
            this.$emit('appliedDiscount', { discount: d })
          } else {
            applied = false
          }
        }

      } else {
        this.$emit('appliedDiscount', { discount: d, applied: applied })
      }
    },
    appliedDiscount(type) {
      if (type == 'percent' || type == 'amount_fixed') this.appliedDiscountPercentOrFixedAmount()
      if (type == 'shipping_free') this.appliedDiscountShippingFree()
    }
  }
}
</script>
